module.exports = __webpack_public_path__ + "img/2021AllotteeOthersInvitation.deaf6e23.jpg";